var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var _loadTimes, _started, _playedCompletely, _skipped;
class AdsStats {
  constructor() {
    /** @type {number[]} */
    __privateAdd(this, _loadTimes, []);
    /** @type {number} */
    __privateAdd(this, _started, 0);
    /** @type {number} */
    __privateAdd(this, _playedCompletely, 0);
    /** @type {number} */
    __privateAdd(this, _skipped, 0);
  }
  /**
   * Record the time it took to get the final manifest.
   *
   * @param {number} seconds
   */
  addLoadTime(seconds) {
    __privateGet(this, _loadTimes).push(seconds);
  }
  /**
   * Increase the number of ads started by one.
   */
  incrementStarted() {
    __privateSet(this, _started, __privateGet(this, _started) + 1);
  }
  /**
   * Increase the number of ads played completely by one.
   */
  incrementPlayedCompletely() {
    __privateSet(this, _playedCompletely, __privateGet(this, _playedCompletely) + 1);
  }
  /**
   * Increase the number of ads skipped by one.
   */
  incrementSkipped() {
    __privateSet(this, _skipped, __privateGet(this, _skipped) + 1);
  }
  /**
   * Create a stats blob that we can pass up to the app. This blob will not
   * reference any internal data.
   *
   * @return {shaka.extern.AdsStats}
   */
  getBlob() {
    return {
      loadTimes: __privateGet(this, _loadTimes),
      started: __privateGet(this, _started),
      playedCompletely: __privateGet(this, _playedCompletely),
      skipped: __privateGet(this, _skipped)
    };
  }
}
_loadTimes = new WeakMap();
_started = new WeakMap();
_playedCompletely = new WeakMap();
_skipped = new WeakMap();

export { AdsStats as default };
//# sourceMappingURL=AdsStats.js.map
